module.exports = __webpack_public_path__ + "img/ab.f83cdf73.png";